<template>
  <section class="company-intro">
    <!-- 背景装饰图 -->
    <div class="intro-bg">
      <img :src="bgImage" alt="" />
    </div>

    <div class="container">
      <div class="intro-grid">
        <!-- 左侧：标题区 -->
        <div class="intro-left">
          <div class="intro-badge scroll-animate fade-up" data-delay="0">
            {{ $i18n.t('company.badge') }}
          </div>
          <h2 class="scroll-animate fade-up" data-delay="100">{{ $i18n.t('company.subtitle') }}</h2>
          <router-link to="/company" class="goKnow scroll-animate fade-up" data-delay="300">
            <span class="btn-icon intro-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </span>
            {{ $i18n.t('company.btnText') }}
          </router-link>
        </div>

        <!-- 右侧：内容 + 图片 -->
        <div class="intro-right">
          <div class="intro-text scroll-animate fade-up" data-delay="200">
            <p>{{ $i18n.t('company.intro') }}</p>
            <p>{{ $i18n.t('company.intro2') }}</p>
          </div>
          <div class="intro-image scroll-animate fade-up" data-delay="400">
            <img :src="contentImage" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useScrollAnimation } from '../composables/useScrollAnimation'

useScrollAnimation()

// 使用 Vite 的 new URL 方式引入图片
const bgImage = new URL('@/assets/pic/bg1.jpg', import.meta.url).href
const contentImage = new URL('@/assets/pic/4.jpg', import.meta.url).href
</script>

<style scoped>
.company-intro {
  position: relative;
  padding: 6.25rem 0;
  overflow: hidden;
  /* background-color: #ffffff; */
}

/* 背景装饰图 - 全屏显示 */
.intro-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.intro-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* opacity: 0.12; */
}

.container {
  position: relative;
  z-index: 1;
  max-width: 87.5rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* 左右两栏布局 */
.intro-grid {
  display: grid;
  grid-template-columns: 26.25rem 1fr;
  gap: 3.75rem;
}

/* ====== 左侧标题区 ====== */
.intro-left {
  padding-right: 1.25rem;
}

.intro-badge {
  display: inline-block;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.13rem;
  margin-bottom: 1.25rem;
}

.intro-left h2 {
  font-size: 2.55rem;
  font-weight: 700;
  color: #4779B5;
  line-height: 1.35;
  margin-bottom: 0.88rem;
}

.intro-coverage {
  font-size: 1.13rem;
  font-weight: 500;
  color: #4779B5;
  margin-bottom: 2rem;
}

/* 圆形箭头按钮 */
.intro-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.63rem;
  width: 3rem;
  height: 3rem;
  background-color: #4779B5;
  border-radius: 50%;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
  justify-content: center;
  position: relative;
}

.intro-btn .btn-text {
  /* 文字隐藏，只显示箭头圆圈 */
  position: absolute;
  left: 3.75rem;
  white-space: nowrap;
  font-size: 0.88rem;
  font-weight: 500;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: #4779B5;
}
.goKnow{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.63rem;
}
.intro-btn:hover {
  background-color: #3A6699;
  transform: translateX(0.25rem);
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ====== 右侧内容+图片 ====== */
.intro-right {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.intro-text p {
  color: #64748b;
  font-size: 1.2rem;
  line-height: 1.95;
  margin-bottom: 0.5rem;
}

.intro-image {
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 0.5rem 1.88rem rgba(0, 0, 0, 0.08);
}

.intro-image img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}

.intro-image:hover img {
  transform: scale(1.03);
}

/* ====== 响应式 ====== */
@media (max-width: 64rem) {
  .intro-grid {
    grid-template-columns: 22.5rem 1fr;
    gap: 2.5rem;
  }

  .intro-left h2 {
    font-size: 1.88rem;
  }
}

@media (max-width: 48rem) {
  .company-intro {
    padding: 3.75rem 0;
  }

  .container {
    padding: 0 1.25rem;
  }

  .intro-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .intro-left {
    padding-right: 0;
  }

  .intro-left h2 {
    font-size: 1.63rem;
  }

  .intro-coverage {
    font-size: 1rem;
  }

  .intro-text p {
    font-size: 0.88rem;
  }
}
</style>
